import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, UserIcon, WalletIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    isAuthenticated,
    user,
    logout
  } = useAuth();
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Goods',
    path: '/goods'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'News',
    path: '/news'
  }, {
    name: 'Events',
    path: '/events'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 sticky top-0 z-50 shadow-lg" data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="flex items-center justify-between h-16" data-id="element-146">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2" data-id="element-147">
            <span className="text-2xl font-bold text-white italic" data-id="element-148">Zinga</span>
            <span className="text-xs text-orange-400 -mt-2" data-id="element-149">
              Login Creatives
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1" data-id="element-150">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`px-3 py-2 text-sm font-medium transition-colors ${isActive(link.path) ? 'text-white bg-blue-700 rounded' : 'text-blue-100 hover:text-white hover:bg-blue-700/50 rounded'}`} data-id="element-151">
                {link.name}
              </Link>)}
          </nav>

          {/* Auth Buttons */}
          <div className="hidden md:flex items-center space-x-3" data-id="element-152">
            {isAuthenticated ? <>
                <Link to="/profile" className="flex items-center space-x-2 text-white hover:text-orange-300 transition-colors" data-id="element-153">
                  <WalletIcon className="w-4 h-4" data-id="element-154" />
                  <span className="text-sm font-medium" data-id="element-155">
                    {user?.walletBalance} KES
                  </span>
                </Link>
                <Link to="/profile" className="flex items-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-156">
                  <UserIcon className="w-4 h-4" data-id="element-157" />
                  <span data-id="element-158">Profile</span>
                </Link>
                <button onClick={logout} className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-159">
                  Logout
                </button>
              </> : <>
                <Link to="/login" className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-160">
                  Login
                </Link>
                <Link to="/signup" className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-161">
                  Sign Up
                </Link>
              </>}
          </div>

          {/* Mobile menu button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-white p-2" aria-label="Toggle menu" data-id="element-162">
            {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-163" /> : <MenuIcon className="w-6 h-6" data-id="element-164" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && <div className="md:hidden pb-4" data-id="element-165">
            <nav className="flex flex-col space-y-1" data-id="element-166">
              {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setMobileMenuOpen(false)} className={`px-3 py-2 text-sm font-medium rounded ${isActive(link.path) ? 'text-white bg-blue-700' : 'text-blue-100 hover:text-white hover:bg-blue-700/50'}`} data-id="element-167">
                  {link.name}
                </Link>)}
              <div className="pt-4 flex flex-col space-y-2" data-id="element-168">
                {isAuthenticated ? <>
                    <div className="text-white px-3 py-2 text-sm" data-id="element-169">
                      Wallet: {user?.walletBalance} KES
                    </div>
                    <Link to="/profile" onClick={() => setMobileMenuOpen(false)} className="bg-green-600 text-white px-3 py-2 rounded text-sm font-medium text-center" data-id="element-170">
                      Profile
                    </Link>
                    <button onClick={() => {
                logout();
                setMobileMenuOpen(false);
              }} className="bg-red-600 text-white px-3 py-2 rounded text-sm font-medium" data-id="element-171">
                      Logout
                    </button>
                  </> : <>
                    <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="bg-red-600 text-white px-3 py-2 rounded text-sm font-medium text-center" data-id="element-172">
                      Login
                    </Link>
                    <Link to="/signup" onClick={() => setMobileMenuOpen(false)} className="bg-orange-500 text-white px-3 py-2 rounded text-sm font-medium text-center" data-id="element-173">
                      Sign Up
                    </Link>
                  </>}
              </div>
            </nav>
          </div>}
      </div>
    </header>;
}